// extracted by mini-css-extract-plugin
export var Section = "Main-module--Section--rNPS6";
export var Slides = "Main-module--Slides--IRvgT";
export var Slide = "Main-module--Slide--qwupZ";
export var NumbersSlide = "Main-module--NumbersSlide--fJyGF";
export var ProjectsSlide = "Main-module--ProjectsSlide--kIEai";
export var AboutSlide = "Main-module--AboutSlide--tHbNk";
export var arrowLeft = "Main-module--arrowLeft--qrMvN";
export var arrowRight = "Main-module--arrowRight--Zp3Fc";